import React from 'react'
import { Button, Dialog, Flex, Text } from '@sendoutcards/quantum-design-ui'
import CallToActionCard from '../CallToActionCard'
import { CarouselCardImages } from './CarouselCardImages'
import { GreetingCardImageLinkType } from './GreetingCardImage'
import { useActions } from 'src/hooks'

type HeartfeltPathDialogProps = {
  cards: GreetingCardImageLinkType[]
  isOpen: boolean
  onClose: () => void
}

export const HeartfeltPathDialog: React.FC<HeartfeltPathDialogProps> = ({
  cards,
  isOpen = false,
  onClose,
}) => {
  const lightThemeButtonBackground = '#383838'
  const actions = useActions()
  return (
    <Dialog isOpen={isOpen} onClose={onClose} insetOverride="x0">
      <CallToActionCard
        isContentCentered={true}
        theme="light"
        tag={{
          icon: 'heartfelt',
          iconColor: 'pink',
          title: "Let's get you started!",
        }}
        title="Have someone in mind or need inspiration?"
        titleSize="subtitle"
        caption="Head over to the card catalog if you already know who you’re sending to or head to your contact manager if your prompting needs a spark."
        graphic={
          <CarouselCardImages
            cardHeight="245px"
            cardWidth="175px"
            gap="40px"
            cardRadius={12}
            cards={cards}
          />
        }
        graphicOrder={2}
        isStacked={true}
        actions={
          <Flex
            alignItems={'center'}
            justifyContent={'center'}
            style={{ gap: 16 }}
            outset={{ vertical: 'x2' }}
          >
            <Button
              title="Browse Contacts"
              onClick={() => actions.openRelationshipManager()}
              backgroundColorOverride={lightThemeButtonBackground}
              outlined={true}
              size="small"
            />
            <Text type="caption" content="or" />
            <Button
              title="Card Catalog"
              onClick={() => actions.openCatalog()}
              backgroundColorOverride={lightThemeButtonBackground}
              size="small"
            />
          </Flex>
        }
      />
    </Dialog>
  )
}
